import { useQuery } from '@tanstack/react-query';
import { getClinicOptions } from '@/services/admin/clinics';

interface UseClinicOptionsQueryOptions {
  enabled?: boolean;
  /** Override global staleTime (e.g. 0 on 拠点作成 for fresh service_type). */
  staleTime?: number;
  refetchOnMount?: boolean | 'always';
}

/**
 * Hook to fetch clinic options for dropdown selection.
 */
export const useClinicOptionsQuery = (siteType: string, options?: UseClinicOptionsQueryOptions) => {
  const enabled = options?.enabled ?? true;
  const staleTime = options?.staleTime;
  const refetchOnMount = options?.refetchOnMount;

  return useQuery({
    queryKey: ['admin', siteType, 'clinics', 'options'],
    queryFn: () => getClinicOptions(siteType),
    enabled: !!siteType && enabled,
    ...(staleTime !== undefined ? { staleTime } : {}),
    ...(refetchOnMount !== undefined ? { refetchOnMount } : {}),
  });
};
